import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../config";
import { toastMessageFailure, toastMessageSuccess } from "../utils/ToastMessage";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {


      await axios.post(
        `${baseUrl}/general/contact-us-email`,
        formData
      );
      toastMessageSuccess('Your email has been sent successfully! We will reply back to you soon.')
      setIsLoading(false);
      // Reset form fields after successful submission
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      toastMessageFailure("Failed to send email. Please try again.")
      console.error("Error submitting form:", error);
      setIsLoading(false);
    }
  };

  return (
    <div id="contact" className="contact-container mb-5">
      <div data-aos="fade-down"
        data-aos-delay="500" className="contact">
        <div className="contact-background">
          <img
            // src="/images/contact-bg.png"
            alt="background"
            className="contact-bg-image"
          />
        </div>
        <div className="container mb-5">
          <div className="row ">
            <div className="col-lg-12 text-center">
              <div className="launch-section">
              {/* <button className="btn-gradient mb-3">Launching soon</button> */}
                <div>
                  The new Stablecoin Standard is launching soon
                  <h1>
                    Stay in touch
                  </h1>
                </div>
              </div>
              <div className="contact-grid">
                <a href="mailto:contact@stabolut.com" className="contact-card">
                  <div className="icon-wrapper mb-4">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                        stroke="url(#paint0_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 6L12 13L2 6"
                        stroke="url(#paint1_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="2"
                          y1="12"
                          x2="22"
                          y2="12"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear"
                          x1="2"
                          y1="9.5"
                          x2="22"
                          y2="9.5"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3>Email</h3>
                  {/* <p>We'll respond as soon as possible</p> */}
                  <span className="contact-link">contact@stabolut.com</span>
                </a>

                <a
                  href="https://t.me/stabolutnews"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card"
                >
                  <div className="icon-wrapper mb-4">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22 2L11 13"
                        stroke="url(#paint0_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 2L15 22L11 13L2 9L22 2Z"
                        stroke="url(#paint1_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="11"
                          y1="7.5"
                          x2="22"
                          y2="7.5"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear"
                          x1="2"
                          y1="12"
                          x2="22"
                          y2="12"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3>Telegram</h3>
                  {/* <p>Join our community</p> */}
                  <span className="contact-link">@stabolutnews</span>
                </a>

                <a
                  href="https://twitter.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card"
                >
                  <div className="icon-wrapper mb-4">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23 3C22.0424 3.67548 20.9821 4.19211 19.86 4.53C19.2577 3.83751 18.4573 3.34669 17.567 3.12393C16.6767 2.90116 15.7395 2.95724 14.8821 3.28445C14.0247 3.61166 13.2884 4.19447 12.773 4.95376C12.2575 5.71305 11.9877 6.61234 12 7.53V8.53C10.2426 8.57557 8.50127 8.18581 6.93101 7.39545C5.36074 6.60508 4.01032 5.43864 3 4C3 4 -1 13 8 17C5.94053 18.398 3.48716 19.0989 1 19C10 24 21 19 21 7.5C20.9991 7.22145 20.9723 6.94359 20.92 6.67C21.9406 5.66349 22.6608 4.39271 23 3V3Z"
                        stroke="url(#paint0_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="1"
                          y1="12"
                          x2="23"
                          y2="12"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3>Twitter</h3>
                  <span className="contact-link">@stabolut</span>
                </a>
                <a
                  href="https://warpcast.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card"
                >
                  <div className="icon-wrapper mb-4">
                    {/* <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23 3C22.0424 3.67548 20.9821 4.19211 19.86 4.53C19.2577 3.83751 18.4573 3.34669 17.567 3.12393C16.6767 2.90116 15.7395 2.95724 14.8821 3.28445C14.0247 3.61166 13.2884 4.19447 12.773 4.95376C12.2575 5.71305 11.9877 6.61234 12 7.53V8.53C10.2426 8.57557 8.50127 8.18581 6.93101 7.39545C5.36074 6.60508 4.01032 5.43864 3 4C3 4 -1 13 8 17C5.94053 18.398 3.48716 19.0989 1 19C10 24 21 19 21 7.5C20.9991 7.22145 20.9723 6.94359 20.92 6.67C21.9406 5.66349 22.6608 4.39271 23 3V3Z"
                        stroke="url(#paint0_linear)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear"
                          x1="1"
                          y1="12"
                          x2="23"
                          y2="12"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8A2BE2" />
                          <stop offset="1" stopColor="#FF69B4" />
                        </linearGradient>
                      </defs>
                    </svg> */}
                    <img src="/images/farcaster.png" alt="" />
                  </div>
                  <h3>Farcaster</h3>
                  <span className="contact-link">stabolut</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/stabolut/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card"
                >
                  <div className="icon-wrapper mb-4">
                    <svg fill="transparent" width="32"
                      height="32" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-linkedin">
                      <defs>
                        <linearGradient id="linkedinGradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#AA38B9" />
                          <stop offset="1" stopColor="#670474" />
                        </linearGradient>
                      </defs>
                      <path d='M19.959 11.719v7.379h-4.278v-6.885c0-1.73-.619-2.91-2.167-2.91-1.182 0-1.886.796-2.195 1.565-.113.275-.142.658-.142 1.043v7.187h-4.28s.058-11.66 0-12.869h4.28v1.824l-.028.042h.028v-.042c.568-.875 1.583-2.126 3.856-2.126 2.815 0 4.926 1.84 4.926 5.792zM2.421.026C.958.026 0 .986 0 2.249c0 1.235.93 2.224 2.365 2.224h.028c1.493 0 2.42-.989 2.42-2.224C4.787.986 3.887.026 2.422.026zM.254 19.098h4.278V6.229H.254v12.869z'
                        fill="url(#linkedinGradient)" />
                    </svg>
                    {/* <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <linearGradient id="linkedinGradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#AA38B9" />
                          <stop offset="1" stopColor="#670474" />
                        </linearGradient>
                      </defs>
                      <path
                        d="M4.98 3.5C4.98 4.33 4.33 5 3.5 5C2.67 5 2 4.33 2 3.5C2 2.67 2.67 2 3.5 2C4.33 2 4.98 2.67 4.98 3.5ZM5 7H2V22H5V7ZM9 7H6V22H9V14C9 11.79 10.79 10 13 10C15.21 10 17 11.79 17 14V22H20V14C20 9.58 16.42 6 12 6C10.66 6 9.42 6.36 8.36 7H9V7Z"
                        fill="url(#linkedinGradient)"
                      />
                    </svg> */}
                  </div>
                  <h3>LinkedIn</h3>
                  <span className="contact-link">stabolut</span>
                </a>




                <a
                  href="https://www.instagram.com/stabolut"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card"
                >
                  <div className="icon-wrapper mb-4">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M24.2499 7.75002H24.2649M8.4999 1H23.4999C27.6421 1 31 4.35787 31 8.50002V23.5001C31 27.6422 27.6421 31.0001 23.4999 31.0001H8.4999C4.35775 31.0001 0.999878 27.6422 0.999878 23.5001V8.50002C0.999878 4.35787 4.35775 1 8.4999 1ZM21.9999 15.055C22.1851 16.3034 21.9718 17.5784 21.3906 18.6986C20.8093 19.8188 19.8897 20.7272 18.7624 21.2946C17.6351 21.862 16.3576 22.0595 15.1116 21.859C13.8656 21.6585 12.7146 21.0702 11.8222 20.1778C10.9298 19.2854 10.3415 18.1344 10.141 16.8884C9.94051 15.6424 10.138 14.3649 10.7054 13.2376C11.2728 12.1103 12.1812 11.1906 13.3014 10.6094C14.4216 10.0281 15.6966 9.81491 16.9449 10C18.2183 10.1889 19.3972 10.7822 20.3075 11.6925C21.2177 12.6028 21.8111 13.7817 21.9999 15.055Z" stroke="url(#paint0_linear_1082_532)" stroke-width="1.59377" stroke-linecap="round" stroke-linejoin="round" />
                      <defs>
                        <linearGradient id="paint0_linear_1082_532" x1="0.999878" y1="16.1424" x2="31" y2="16.1424" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#AA38B9" />
                          <stop offset="1" stop-color="#670474" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3>Instagram</h3>
                  <span className="contact-link">stabolut</span>
                </a>


              </div>


            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-12">
              <form
                onSubmit={handleSubmit}
                className="contact-card text-start bg-white"
              >
                <div className="row justify-content-start">
                  <div className="col-lg-6 mb-4">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Name"
                      required
                    />
                  </div>

                  {/* <div className="col-lg-6 mb-4">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Last name"
                      required
                    />
                  </div> */}

                  <div className="col-lg-6 mb-4">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                      required
                    />
                  </div>
                  {/* <div className="col-lg-6 mb-4">
                    <label>Phone Number (Optional)</label>

                    <PhoneInput
                      international
                      // countryCallingCodeEditable={false}
                      value={formData.phone}
                      placeholder="Enter Phone Number"
                      defaultCountry="AU"
                      onChange={(value) => setFormData({ ...formData, phone: value })}
                    />

                  </div> */}
                  <div className="col-lg-12 mb-4">
                    <label>Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      style={{ height: "150px" }}
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>
                  <div className="col-lg-12">
                    <button
                      type="submit"
                      className={`btn-gradient w-100 text-center justify-content-center rounded-1 ${isLoading ? "loading" : ""
                        }`}
                      disabled={isLoading}
                    >
                      {isLoading ? <div className="spinner"></div> : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
